import React from "react";

interface MatchProps {
  readonly children: React.ReactNode;
  readonly when: boolean;
}

export function Switch({ children }: { children: React.ReactNode }) {
  const arrayChildren = React.Children.toArray(children);

  for (const child of arrayChildren) {
    if (
      React.isValidElement<MatchProps>(child) &&
      child.type === Match &&
      (child.props as { when?: boolean }).when
    ) {
      return child;
    }
  }

  return null;
}

export function Match({ children, when: _when }: MatchProps) {
  // Match should not conditionally render here;
  // Switch already decides which Match is active.
  // The 'when' prop is used by Switch to determine which Match to render.
  return <>{children}</>;
}
